import "moment-timezone";

import React, { Component, useEffect, useRef, useState } from "react";

import Moment from "react-moment";
import ReactDOM from "react-dom";
import { SpinnerComponent } from "react-element-spinner";

class ListPage {
    constructor(element) {
        this.element = element;
        this.view = element.querySelector(".js-list-page__root");
        this.init();
    }

    init() {
        ReactDOM.render(<ListPageView />, this.view);
    }
}

class ListPageView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedMainCategory: this.getInitMainCategory(),
            selectedSubCategory: "",
            selectedSubCategoryText: episerver_defaultSelect,
            mainCategories: episerver_listPageCategories,
            filterMode: episerver_filterMode,
            subCategories: this.getSubCategories(
                episerver_listPageCategories,
                this.getInitMainCategory()
            ),
            items: [],
            isLoading: true,
        };
    }

    componentDidMount() {
        this.fetchItems("", "");
    }

    getInitMainCategory() {
        return episerver_listPageCategories !== undefined
            ? episerver_listPageCategories[0].CategoryId
            : "";
    }

    getSubCategories(categories, selectedCategory) {
        var category = categories.find((c) => c.CategoryId === selectedCategory);
        if (category) {
            return category.Children;
        } else {
            return [];
        }
    }

    fetchItems(mainCategory, subCategory) {
        let categoryId =
            episerver_listPageCategories !== undefined
                ? episerver_listPageCategories[0].CategoryId
                : episerver_currentContainerId;

        if (subCategory !== "") {
            categoryId = subCategory;
        } else if (mainCategory !== "") {
            categoryId = mainCategory;
        }

        const fetchUrl = `${episerver_listEndpoint}${categoryId}/${episerver_local}/items`;

        const fetchSettings = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        };

        this.setState({ isLoading: true });

        fetch(fetchUrl, fetchSettings)
            .then((res) => res.json())
            .then((items) => {
                this.setState({ isLoading: false });
                this.setState({ items: items });
            });
    }

    handleMainCategoryChange(categoryId) {
        this.setState(
            {
                selectedMainCategory: categoryId,
                selectedSubCategory: "",
                selectedSubCategoryText: episerver_defaultSelect,
                subCategories: this.getSubCategories(
                    episerver_listPageCategories,
                    categoryId
                ),
            },
            () => this.fetchItems(this.state.selectedMainCategory, "")
        );
    }

    handleSubCategoryChange(categoryId) {
        this.setState({ selectedSubCategory: categoryId }, () =>
            this.fetchItems(
                this.state.selectedMainCategory,
                this.state.selectedSubCategory
            )
        );
    }

    render() {
        return (
            <div className="pagecomponent--70 list-page__view">
                <MainCategories
                    handleLevelFilterChange={(categoryId) =>
                        this.handleMainCategoryChange(categoryId)
                    }
                    selectedCategory={this.state.selectedMainCategory}
                    filterMode={this.state.filterMode}
                    items={this.state.mainCategories}
                />
                <SubCategories
                    selectedFilterText={this.state.selectedSubCategoryText}
                    setSelectedText={(text) =>
                        this.setState({ selectedSubCategoryText: text })
                    }
                    handleSelect={(id) => this.handleSubCategoryChange(id)}
                    filterMode={this.state.filterMode}
                    items={this.state.subCategories}
                />
                <ItemList
                    scope={this}
                    items={this.state.items}
                    isLoading={this.state.isLoading}
                />
            </div>
        );
    }
}

function useOutsideAlerter(ref, callback) {
    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                callback();
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
}

function MainCategories(props) {
    const [categoryElements, setCategoryElements] = useState([]);

    useEffect(() => {
        createElemList();
    }, [props.selectedCategory]);

    function createElemList() {
        var elems = [];
        var selected = "";
        if (props.items) {
            props.items.map((item, i) => {
                selected =
                    item.CategoryId === props.selectedCategory
                        ? "list-page__active-filter-tab"
                        : "";
                elems.push(
                    <div
                        onClick={() => props.handleLevelFilterChange(item.CategoryId)}
                        key={`level1-filter-control-${i}`}
                        role="button"
                        tabIndex="0"
                        className={"col-sm list-page__filter-tab " + selected}
                    >
                        {item.Title}
                    </div>
                );
            });
            setCategoryElements(elems);
        }
    }

    return props.filterMode !== "None" ? (
        <div className="container no-padding list-page__filter_container">
            <div className="row">{categoryElements}</div>
        </div>
    ) : null;
}

function SubCategories(props) {
    const [displayDropdown, setdisplayDropdown] = useState(false);
    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef, () => setdisplayDropdown(false));

    var items = [];

    props.items.forEach((item) => {
        items.push(
            <div
                key={item.CategoryId}
                value={item.Title}
                onClick={(e) => {
                    props.setSelectedText(item.Title);
                    props.handleSelect(item.CategoryId);
                }}
            >
                {item.Title}
            </div>
        );
    });

    if (items.length > 0) {
        return (
            <>
                <div className="container no-padding list-page__filter_container">
                    <div className="row no-padding justify-content-center">
                        <div
                            ref={wrapperRef}
                            className="col-sm-4 no-padding filter-selector"
                            onClick={() =>
                                displayDropdown
                                    ? setdisplayDropdown(false)
                                    : setdisplayDropdown(true)
                            }
                        >
                            <div className="filter_text">
                                <SpinnerComponent
                                    loading={props.isLoading}
                                    spinnerType="circle-dots"
                                    position="centered"
                                    backgroundColor="#dddddd"
                                />
                                {props.selectedFilterText}
                            </div>
                            {displayDropdown ? (
                                <div className="container no-padding">
                                    <div className="row no-padding justify-content-center">
                                        <div className="col filter_content">{items}</div>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </>
        );
    } else {
        return null;
    }
}

function ItemList(props) {
    function rows(reportsToDisplay, itemRenderer, itemFileRenderer) {
        var output = [],
            itemTmp = null;
        for (let index = 0; index < reportsToDisplay.length; index++) {
            if ((index + 1) % 2 == 0) {
                output.push(
                    row(
                        itemTmp,
                        reportsToDisplay[index],
                        index,
                        itemRenderer,
                        itemFileRenderer
                    )
                );
                itemTmp = null;
            } else {
                itemTmp = reportsToDisplay[index];
            }
        }
        if (itemTmp)
            output.push(
                row(
                    itemTmp,
                    null,
                    reportsToDisplay.length,
                    itemRenderer,
                    itemFileRenderer
                )
            );
        return output;
    }

    function row(item1, item2, index, itemRenderer, itemFileRenderer) {
        return (
            <div className="container no-padding" key={index}>
                <div className="row">
                    {item1.IsFile ? itemFileRenderer(item1) : itemRenderer(item1)}
                    {item2
                        ? item2.IsFile
                            ? itemFileRenderer(item2)
                            : itemRenderer(item2)
                        : null}
                </div>
            </div>
        );
    }

    function rowItem(item) {
        return (
            <div className="col-sm-6 no-padding">
                <div className="list-page__item">
                    <div className="download-block-text date">
                        <Moment
                            className="date_text"
                            locale={episerver_local}
                            format="DD MMMM, yyyy"
                        >
                            {item.Date}
                        </Moment>
                    </div>
                    <div className="title">
                        <a href={item.Link}>{item.Title}</a>
                    </div>
                </div>
            </div>
        );
    }

    function rowFileItem(item) {
        return (
            <div className="col-sm-6 no-padding">
                <div className="list-page__item file-item">
                    <div className="filedownloadblock__grid-item">
                        <div className="filedownloadblock__image"></div>
                        <button
                            className="filedownloadblock__button"
                            type="button"
                            onClick={(e) => {
                                e.currentTarget.querySelector("a.download-block-text.metadata").click();
                            }}
                        >
                            <div className="filedownloadblock__content">
                                <div className="download-block-text date">
                                    <Moment
                                        className="date_text"
                                        locale={episerver_local}
                                        format="DD MMMM, yyyy"
                                    >
                                        {item.Date}
                                    </Moment>
                                </div>
                                <a className="download-block-text metadata" target={episerver_linkTarget} href={item.Link}>{item.Title}</a>
                            </div>
                            <div className="filedownloadblock__icon">
                                <img src="/Static/icons/download.svg" />
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="list-page__filter_container container no-padding containerItems">
            {props.isLoading ? (
                <div className="list-page__wait-indicator">
                    <em>{episerver_loadingText}</em>
                </div>
            ) : props.items ? (
                <>{rows(props.items, rowItem, rowFileItem)}</>
            ) : null}
        </div>
    );
}

export default ListPage;
